// import notification from '../../../services/notification-service'

export default {
    name: 'File',
    data() {
        return {
            filename: ''
        }
    },
    methods: {
        getFileData() {
            let filename = event.target.files[0].name;
            let filetype = filename.split('.')[1];
            this.fileName = filename;

            if(filetype == 'csv') {
                this.getFileFromCSV(event);
            } else if (filetype == 'xlsx' || filetype== 'xls'){
                this.getFileFromExcel(event);
            } else {
                // notification.notify('Helaas!', 'Het uploaden is niet gelukt', 'error')
            }
        },
        getFileFromCSV(event) {
            const input = event.target
            if ('files' in input && input.files.length > 0) {
                this.$papa.parse(input.files[0],{
                    complete: this.procesData,
                    dynamicTyping: true,
                    header: false
                })
            }
        },
        getFileFromExcel(event) {
            var files = event.target.files, f = files[0];
            var reader = new FileReader();
            reader.onload = e => {
                var data = new Uint8Array(e.target.result);
                var workbook = this.$xlsx.read(data, {type: 'array'});
                this.to_json(workbook)
            };
            reader.readAsArrayBuffer(f);
        }
    }
}
